import { useEnv } from '@btcdirect/shared/src/composables/util/env';
import { useLogger } from '@btcdirect/shared/src/composables/util/logger';

export interface Localization {
    locale: string;
    country: string;
    language: string;
}

const DEFAULT_LOCALE = useEnv().getString('VITE_DEFAULT_LOCALE', 'en-GB').toLowerCase();

const { warn } = useLogger();

export function parseLocale(locale: string): Localization {
    if (!locale || !/^\w{2}-\w{2}$/.test(locale)) {
        warn(`Locale ${locale} could not be parsed, reverting to default ${DEFAULT_LOCALE}`);
        locale = DEFAULT_LOCALE;
    }

    const lowered = locale.toLowerCase();
    const parts = lowered.split('-');

    return {
        locale: lowered,
        country: parts[1],
        language: parts[0]
    };
}
